/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskUpdateDto } from '../../models/core-project-subtask-update-dto';

export interface ProjectSubtasksControllerUpdateByTaskId$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The task ID.
 */
  taskId: string;
      body: CoreProjectSubtaskUpdateDto
}

export function projectSubtasksControllerUpdateByTaskId(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerUpdateByTaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerUpdateByTaskId.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('taskId', params.taskId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as CoreStrictHttpResponse<void>;
    })
  );
}

projectSubtasksControllerUpdateByTaskId.PATH = '/o2-core/project-subtasks/{tenant}/task/{taskId}';
